import { useAuthentication } from '@context/businessContainer';
import { useShoppingCart } from './cart/useShoppingCart';

const useShouldHideTotalPrice = (): boolean => {
  const { isAuthenticated } = useAuthentication();
  const { shoppingCart } = useShoppingCart();
  const shouldHideTotalPrice = Boolean(
    !isAuthenticated && shoppingCart.hasHiddenPrice,
  );

  return shouldHideTotalPrice;
};

export default useShouldHideTotalPrice;
